import { render, staticRenderFns } from "./searchPage.vue?vue&type=template&id=64611506&scoped=true&"
import script from "./searchPage.vue?vue&type=script&lang=js&"
export * from "./searchPage.vue?vue&type=script&lang=js&"
import style0 from "./searchPage.vue?vue&type=style&index=0&id=64611506&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "64611506",
  null
  
)

export default component.exports